import styled, { css } from 'styled-components/macro';

export const SegementedWrapper = styled.div<{ isLoading?: boolean }>`
  box-sizing: border-box;
  width: auto;
  height: 40px;
  background: ${props => props.theme.colors.neutral[10]};
  border-radius: 24px;
  padding: 4px;
  display: flex;
  align-items: center;
  position: relative;
  gap: 8px;
  padding:0 6px
  min-width: 0;
   ${props =>
     props.isLoading &&
     css`
       cursor: not-allowed;
       opacity: 0.5;
       pointer-events: none;
     `}
`;

export const SegmentedControlItem = styled.div<{
  active?: boolean;
  disabled?: boolean;
  isLive?: boolean;
  isLocked?: boolean;
}>`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  color: ${props => props.theme.colors.neutral[60]};
  padding: 0 6px;
  cursor: pointer;
  & > * {
    min-width: 0;
    max-width: 100%;
    flex: 1 1 auto;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

  ${props =>
    (props.isLive || props.isLocked) &&
    css`
      cursor: not-allowed;
    `}

  ${props =>
    props.active &&
    css`
      background: ${props.theme.colors.white[100]};
      height: 32px;
      z-index: 2;
      opacity: 1;
      color: ${props.theme.colors.primary[100]};
      border-radius: 16px;
      cursor: pointer;
      box-shadow: 0px 2px 4px rgba(29, 30, 36, 0.04);
    `}
`;

export const LabelWrap = styled.div`
  display: block;
`;

export const LockRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; /* center text+icon as a group */
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
`;

/* Text area that can ellipsize but doesn't push the icon away */
export const TextWrap = styled.div`
  max-width: calc(100% - 22px);
`;

/* Icon must not shrink */
export const IconWrap = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
  }
`;
